module.exports={
    "debugbar.openhandler": "_debugbar\/open",
    "debugbar.clockwork": "_debugbar\/clockwork\/{id}",
    "debugbar.assets.css": "_debugbar\/assets\/stylesheets",
    "debugbar.assets.js": "_debugbar\/assets\/javascript",
    "debugbar.cache.delete": "_debugbar\/cache\/{key}\/{tags?}",
    "": "admin",
    "home": "\/",
    "product.category": "category\/{area_slug}\/{category_slug}",
    "product.category.line": "category\/{area_slug}\/{category_slug}\/line\/{line_slug}",
    "product.show": "category\/{area_slug}\/{category_slug}\/product\/{product}",
    "news.index": "news",
    "news.category": "news\/{category_slug}",
    "news.show": "news\/{category_slug}\/{news}",
    "retailer.index": "retailer",
    "partner.index": "partner",
    "feedback.index": "feedback",
    "feedback.send": "feedback",
    "contacts": "contacts",
    "services": "services",
    "downloads": "download",
    "download.product": "download\/product",
    "download.product.show": "download\/product\/{product}",
    "download.serial": "download\/serial",
    "catalog": "catalog",
    "product-line": "catalog\/1",
    "product": "product",
    "shops": "shops",
    "search": "search",
    "press": "press",
    "article": "article",
    "about": "about",
    "login": "admin\/login",
    "logout": "admin\/logout",
    "register": "admin\/register",
    "password.request": "admin\/password\/reset",
    "password.email": "admin\/password\/email",
    "password.reset": "admin\/password\/reset\/{token}",
    "admin.common.sort": "admin\/common\/sort",
    "admin.common.toggle": "admin\/common\/toggle",
    "admin.common.upload": "admin\/common\/upload",
    "admin.common.delete_upload": "admin\/common\/upload\/{upload}",
    "admin.gallery.store": "admin\/gallery",
    "admin.gallery.items": "admin\/gallery",
    "admin.gallery.delete_item": "admin\/gallery",
    "admin.area.index": "admin\/area",
    "admin.area.create": "admin\/area\/create",
    "admin.area.store": "admin\/area",
    "admin.area.edit": "admin\/area\/{area}\/edit",
    "admin.area.update": "admin\/area\/{area}",
    "admin.area.destroy": "admin\/area\/{area}",
    "admin.line.index": "admin\/line",
    "admin.line.create": "admin\/line\/create",
    "admin.line.store": "admin\/line",
    "admin.line.edit": "admin\/line\/{line}\/edit",
    "admin.line.update": "admin\/line\/{line}",
    "admin.line.destroy": "admin\/line\/{line}",
    "admin.product.index": "admin\/product",
    "admin.product.create": "admin\/product\/create",
    "admin.product.store": "admin\/product",
    "admin.product.show": "admin\/product\/{product}",
    "admin.product.edit": "admin\/product\/{product}\/edit",
    "admin.product.update": "admin\/product\/{product}",
    "admin.product.destroy": "admin\/product\/{product}",
    "admin.category.index": "admin\/category",
    "admin.category.create": "admin\/category\/create",
    "admin.category.store": "admin\/category",
    "admin.category.edit": "admin\/category\/{category}\/edit",
    "admin.category.update": "admin\/category\/{category}",
    "admin.category.destroy": "admin\/category\/{category}",
    "admin.feature.index": "admin\/feature",
    "admin.feature.create": "admin\/feature\/create",
    "admin.feature.store": "admin\/feature",
    "admin.feature.edit": "admin\/feature\/{feature}\/edit",
    "admin.feature.update": "admin\/feature\/{feature}",
    "admin.feature.destroy": "admin\/feature\/{feature}",
    "admin.category.property.index": "admin\/category\/{category}\/property",
    "admin.category.property.create": "admin\/category\/{category}\/property\/create",
    "admin.category.property.store": "admin\/category\/{category}\/property",
    "admin.category.property.edit": "admin\/category\/{category}\/property\/{property}\/edit",
    "admin.category.property.update": "admin\/category\/{category}\/property\/{property}",
    "admin.category.property.destroy": "admin\/category\/{category}\/property\/{property}",
    "admin.category.property_group.index": "admin\/category\/{category}\/property_group",
    "admin.category.property_group.create": "admin\/category\/{category}\/property_group\/create",
    "admin.category.property_group.store": "admin\/category\/{category}\/property_group",
    "admin.category.property_group.edit": "admin\/category\/{category}\/property_group\/{property_group}\/edit",
    "admin.category.property_group.update": "admin\/category\/{category}\/property_group\/{property_group}",
    "admin.category.property_group.destroy": "admin\/category\/{category}\/property_group\/{property_group}",
    "admin.category.filter.index": "admin\/category\/{category}\/filter",
    "admin.category.filter.create": "admin\/category\/{category}\/filter\/create",
    "admin.category.filter.store": "admin\/category\/{category}\/filter",
    "admin.category.filter.edit": "admin\/category\/{category}\/filter\/{filter}\/edit",
    "admin.category.filter.update": "admin\/category\/{category}\/filter\/{filter}",
    "admin.category.filter.destroy": "admin\/category\/{category}\/filter\/{filter}",
    "admin.product.product_file.index": "admin\/product\/{product}\/product_file",
    "admin.product.product_file.create": "admin\/product\/{product}\/product_file\/create",
    "admin.product.product_file.store": "admin\/product\/{product}\/product_file",
    "admin.product.product_file.edit": "admin\/product\/{product}\/product_file\/{product_file}\/edit",
    "admin.product.product_file.update": "admin\/product\/{product}\/product_file\/{product_file}",
    "admin.product.product_file.destroy": "admin\/product\/{product}\/product_file\/{product_file}",
    "admin.property.property_value.store": "admin\/property\/{property}\/property_value",
    "admin.property.property_value.update": "admin\/property\/{property}\/property_value\/{property_value}",
    "admin.property.property_value.destroy": "admin\/property\/{property}\/property_value\/{property_value}",
    "admin.filter.filter_interval.store": "admin\/filter\/{filter}\/filter_interval",
    "admin.filter.filter_interval.update": "admin\/filter\/{filter}\/filter_interval\/{filter_interval}",
    "admin.filter.filter_interval.destroy": "admin\/filter\/{filter}\/filter_interval\/{filter_interval}",
    "admin.menu.index": "admin\/menu",
    "admin.menu.menu_item.index": "admin\/menu\/{menu}\/menu_item",
    "admin.menu.menu_item.create": "admin\/menu\/{menu}\/menu_item\/create",
    "admin.menu.menu_item.store": "admin\/menu\/{menu}\/menu_item",
    "admin.menu.menu_item.edit": "admin\/menu\/{menu}\/menu_item\/{menu_item}\/edit",
    "admin.menu.menu_item.update": "admin\/menu\/{menu}\/menu_item\/{menu_item}",
    "admin.menu.menu_item.destroy": "admin\/menu\/{menu}\/menu_item\/{menu_item}",
    "admin.menu.menu_item.sort": "admin\/menu\/{menu}\/menu_item\/sort",
    "admin.city.index": "admin\/city",
    "admin.city.create": "admin\/city\/create",
    "admin.city.store": "admin\/city",
    "admin.city.edit": "admin\/city\/{city}\/edit",
    "admin.city.update": "admin\/city\/{city}",
    "admin.city.destroy": "admin\/city\/{city}",
    "admin.service_center.index": "admin\/service_center",
    "admin.service_center.create": "admin\/service_center\/create",
    "admin.service_center.store": "admin\/service_center",
    "admin.service_center.edit": "admin\/service_center\/{service_center}\/edit",
    "admin.service_center.update": "admin\/service_center\/{service_center}",
    "admin.service_center.destroy": "admin\/service_center\/{service_center}",
    "admin.news.index": "admin\/news",
    "admin.news.create": "admin\/news\/create",
    "admin.news.store": "admin\/news",
    "admin.news.edit": "admin\/news\/{news}\/edit",
    "admin.news.update": "admin\/news\/{news}",
    "admin.news.destroy": "admin\/news\/{news}",
    "admin.news_category.index": "admin\/news_category",
    "admin.news_category.create": "admin\/news_category\/create",
    "admin.news_category.store": "admin\/news_category",
    "admin.news_category.edit": "admin\/news_category\/{news_category}\/edit",
    "admin.news_category.update": "admin\/news_category\/{news_category}",
    "admin.news_category.destroy": "admin\/news_category\/{news_category}",
    "admin.retailer.index": "admin\/retailer",
    "admin.retailer.create": "admin\/retailer\/create",
    "admin.retailer.store": "admin\/retailer",
    "admin.retailer.edit": "admin\/retailer\/{retailer}\/edit",
    "admin.retailer.update": "admin\/retailer\/{retailer}",
    "admin.retailer.destroy": "admin\/retailer\/{retailer}",
    "admin.partner.index": "admin\/partner",
    "admin.partner.create": "admin\/partner\/create",
    "admin.partner.store": "admin\/partner",
    "admin.partner.edit": "admin\/partner\/{partner}\/edit",
    "admin.partner.update": "admin\/partner\/{partner}",
    "admin.partner.destroy": "admin\/partner\/{partner}",
    "admin.banner.index": "admin\/banner",
    "admin.banner.create": "admin\/banner\/create",
    "admin.banner.store": "admin\/banner",
    "admin.banner.edit": "admin\/banner\/{banner}\/edit",
    "admin.banner.update": "admin\/banner\/{banner}",
    "admin.banner.destroy": "admin\/banner\/{banner}",
    "admin.color.index": "admin\/color",
    "admin.color.create": "admin\/color\/create",
    "admin.color.store": "admin\/color",
    "admin.color.edit": "admin\/color\/{color}\/edit",
    "admin.color.update": "admin\/color\/{color}",
    "admin.color.destroy": "admin\/color\/{color}",
    "admin.feedback.index": "admin\/feedback",
    "admin.feedback.show": "admin\/feedback\/{feedback}",
    "admin.feedback.destroy": "admin\/feedback\/{feedback}",
    "admin.config.index": "admin\/config",
    "admin.config.edit": "admin\/config\/{config}\/edit",
    "admin.config.update": "admin\/config\/{config}",
    "admin.product_file_import.index": "admin\/product_file_import",
    "admin.product_file_import.upload": "admin\/product_file_import",
    "admin.product_file_import.show": "admin\/product_file_import\/{product_file_import}",
    "admin.product.properties": "admin\/product\/{product}\/properties",
    "admin.product.features": "admin\/product\/{product}\/features"
}